import { mapGetters } from 'vuex';

import { getFieldLocale } from '@/utils/field';

/**
 * Breakdown name priority
 * 1. Custom Breakdown (GET /customBreakdowns)
 * 2. Locale from BE
 * 3. Locale from FE
 */
export default {
    name: 'BreakdownTranslatorMixin',
    computed: {
        ...mapGetters('user', ['isQa']),
        ...mapGetters('newDashboard', ['dimensionById']),
    },
    methods: {
        getCustomBreakdownName(key) {
            return (
                this.dimensionById[Number(key)]?.name ||
                this.$t(`COMMON.deleted_field`)
            );
        },

        /**
         * 메인 함수
         */
        _getBreakdownName(breakdown) {
            const { getCustomBreakdownName } = this;
            const { key, isCustom, locale: localeFromBE } = breakdown;

            return isCustom
                ? getCustomBreakdownName(key)
                : localeFromBE || getFieldLocale.call(this, key);
        },
        _getBreakdownNameWithRawName(breakdown) {
            const { _getBreakdownName } = this;
            const { key } = breakdown;

            return `[${key}]-${_getBreakdownName(breakdown)}`;
        },
        getBreakdownName(breakdown) {
            const { isQa, _getBreakdownName, _getBreakdownNameWithRawName } =
                this;
            return isQa
                ? _getBreakdownNameWithRawName(breakdown)
                : _getBreakdownName(breakdown);
        },
    },
};
